/**
 * SEO-Helfer zur Generierung von SEO-freundlichen URLs und kanonischen Pfaden
 */

/**
 * Mapping von alten/Legacy-Pfaden zu SEO-optimierten deutschen Pfaden
 */
const pathMap: Record<string, string> = {
  '': 'startseite',                // Startseite/Root
  '/': 'startseite',               // Startseite/Root
  '/consulting': '/beratung',
  '/erp': '/erp-systeme',
  '/shopware': '/shopware',
  '/business-apps': '/business-anwendungen',
  '/mobile-apps': '/mobile-apps',
  '/interfaces': '/schnittstellen',
  '/portals': '/portale',
  '/salescockpit': '/salescockpit',
  '/references': '/referenzen',
  '/about': '/ueber-uns',
  '/cto-service': '/cto-service',
  '/datenschutz': '/datenschutz',
  '/impressum': '/impressum',
  '/agb': '/agb',
  '/e-commerce': '/e-commerce',
  '/shopware-entwicklung': '/shopware-entwicklung'
};

/**
 * Generiert einen SEO-optimierten kanonischen Pfad für die angegebene Route
 * 
 * @param legacyPath Der alte Pfad oder eine Route ohne /de/ Präfix
 * @returns Einen SEO-optimierten kanonischen Pfad mit /de/ Präfix
 */
export const getCanonicalPath = (legacyPath: string): string => {
  // Entferne führenden Slash für den Lookup
  const normalisedPath = legacyPath.startsWith('/') ? legacyPath : `/${legacyPath}`;
  const seoPath = pathMap[normalisedPath] || normalisedPath.slice(1);
  
  return `/de${seoPath.startsWith('/') ? seoPath : `/${seoPath}`}`;
};

/**
 * Generiert einen absoluten kanonischen URL für die angegebene Route
 * 
 * @param legacyPath Der alte Pfad oder eine Route ohne /de/ Präfix
 * @returns Einen absoluten kanonischen URL mit der Basis-URL und dem optimierten Pfad
 */
export const getCanonicalUrl = (legacyPath: string): string => {
  const baseUrl = 'https://www.splusd-solutions.com';
  return `${baseUrl}${getCanonicalPath(legacyPath)}`;
}; 